module.exports = __webpack_public_path__ + "packs/media/images/junglephoto-ca4e502187e388dda24f33c5577a2e17.jpg";